import { ReactComponent as LogoSantaHat } from './santa-hat.svg';
import { ReactComponent as ProfileIconMistletoe } from './mistletoe.svg';
import { ReactComponent as SidebarBottomSnowman } from './snowman.svg';

const ChristmasIcons = { LogoSantaHat, ProfileIconMistletoe, SidebarBottomSnowman };

export default ChristmasIcons;
